import Vue from 'vue'
import { MutationTree } from 'vuex'

import { OptionGroup } from '@/models'

import { makeRelationalObject } from '../../models'
import { ItemGroupOptionGroups, MenuState } from '../state'

export const ADD_OPTION_GROUP = 'ADD_OPTION_GROUP'
export const ADD_ITEM_GROUP_OPTION_GROUPS = 'ADD_ITEM_GROUP_OPTION_GROUPS'
export const CLEAR_ITEM_GROUPS_OPTION_GROUPS = 'CLEAR_ITEM_GROUPS_OPTION_GROUPS'
export const INCREMENT_ITEM_GROUP_OPTION_GROUPS_QUERY_INDEX = 'INCREMENT_ITEM_GROUP_OPTION_GROUPS_QUERY_INDEX'
export const LOADED_ALL_ITEM_GROUP_OPTION_GROUPS = 'LOADED_ALL_ITEM_GROUP_OPTION_GROUPS'
export const REMOVE_ITEM_GROUP_OPTION_GROUP = 'REMOVE_ITEM_GROUP_OPTION_GROUP'
export const REMOVE_ITEM_GROUP_OPTION_GROUPS = 'REMOVE_ITEM_GROUP_OPTION_GROUPS'
export const REMOVE_OPTION_GROUP = 'REMOVE_OPTION_GROUP'
export const RESET_ITEM_GROUP_OPTION_GROUPS_QUERY_INDEX = 'RESET_ITEM_GROUP_OPTION_GROUPS_QUERY_INDEX'
export const RESET_LOADED_ALL_ITEM_GROUP_OPTION_GROUPS = 'RESET_LOADED_ALL_ITEM_GROUP_OPTION_GROUPS'
export const UPDATE_ITEM_GROUP_OPTION_GROUPS = 'UPDATE_ITEM_GROUP_OPTION_GROUPS'
export const UPDATE_ITEM_GROUP_OPTION_GROUPS_TOTAL = 'UPDATE_ITEM_GROUP_OPTION_GROUPS_TOTAL'
export const UPDATE_OPTION_GROUPS = 'UPDATE_OPTION_GROUPS'

const mutations: MutationTree<MenuState> = {
  [ADD_OPTION_GROUP] (state, optionGroup: OptionGroup) {
    state.optionGroups.elements.push(optionGroup)
  },

  [ADD_ITEM_GROUP_OPTION_GROUPS] (state, itemGroupId: number) {
    const itemGroupOptionGroups: ItemGroupOptionGroups = {
      ...makeRelationalObject(),
      query: {}
    }

    Vue.set(state.itemGroups.optionGroups, itemGroupId, itemGroupOptionGroups)
  },

  [CLEAR_ITEM_GROUPS_OPTION_GROUPS] (state) {
    state.itemGroups.optionGroups = {}
  },

  [INCREMENT_ITEM_GROUP_OPTION_GROUPS_QUERY_INDEX] (
    state,
    { itemGroupId, offset }: { itemGroupId: number; offset: number }
  ) {
    const itemGroupOptionGroups = state.itemGroups.optionGroups[itemGroupId]

    if (itemGroupOptionGroups === undefined) {
      throw new Error(`OptionGroups relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupOptionGroups.query.index = (itemGroupOptionGroups.query.index ?? 0) + offset
  },

  [LOADED_ALL_ITEM_GROUP_OPTION_GROUPS] (state, itemGroupId: number) {
    const itemGroupOptionGroups = state.itemGroups.optionGroups[itemGroupId]

    if (itemGroupOptionGroups === undefined) {
      throw new Error(`OptionGroups relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupOptionGroups.didLoadAll = true
  },

  [REMOVE_ITEM_GROUP_OPTION_GROUP] (
    state,
    { id, itemGroupId }: { id: number; itemGroupId: number }
  ) {
    const itemGroupOptionGroups = state.itemGroups.optionGroups[itemGroupId]

    if (itemGroupOptionGroups === undefined) {
      throw new Error(`OptionGroups relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupOptionGroups.ids.delete(id)
  },

  [REMOVE_ITEM_GROUP_OPTION_GROUPS] (state, itemGroupId: number) {
    Vue.delete(state.itemGroups.optionGroups, itemGroupId)
  },

  [REMOVE_OPTION_GROUP] (state, id: number) {
    const index = state.optionGroups.elements.findIndex((i) => i.id === id)

    if (index >= 0) {
      state.optionGroups.elements.splice(index, 1)
    }
  },

  [RESET_ITEM_GROUP_OPTION_GROUPS_QUERY_INDEX] (state, itemGroupId: number) {
    const itemGroupOptionGroups = state.itemGroups.optionGroups[itemGroupId]

    if (itemGroupOptionGroups === undefined) {
      throw new Error(`OptionGroups relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupOptionGroups.query.index = 0
  },

  [RESET_LOADED_ALL_ITEM_GROUP_OPTION_GROUPS] (state, itemGroupId: number) {
    const itemGroupOptionGroups = state.itemGroups.optionGroups[itemGroupId]

    if (itemGroupOptionGroups === undefined) {
      throw new Error(`OptionGroups relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupOptionGroups.didLoadAll = false
  },

  [UPDATE_ITEM_GROUP_OPTION_GROUPS] (
    state,
    { itemGroupId, optionGroups }: { itemGroupId: number; optionGroups: number[] }
  ) {
    const itemGroupOptionGroups = state.itemGroups.optionGroups[itemGroupId]

    if (itemGroupOptionGroups === undefined) {
      throw new Error(`OptionGroups relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupOptionGroups.ids = new Set(optionGroups)
  },

  [UPDATE_ITEM_GROUP_OPTION_GROUPS_TOTAL] (
    state,
    { itemGroupId, total }: { itemGroupId: number; total: number }
  ) {
    const itemGroupOptionGroups = state.itemGroups.optionGroups[itemGroupId]

    if (itemGroupOptionGroups === undefined) {
      throw new Error(`OptionGroups relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupOptionGroups.total = total
  },

  [UPDATE_OPTION_GROUPS] (state, optionGroups: OptionGroup[]) {
    state.optionGroups.elements = optionGroups
  }
}

export default mutations
